module.exports = __webpack_public_path__ + "img/approveSuc.830b95b2.png";